import React, { FC } from 'react';
import { useLocation } from 'react-router-dom';

import { USER_SIDEBAR_MENU } from '../../constants';

const UserHeading: FC = () => {
  const location = useLocation();

  const currentItem = USER_SIDEBAR_MENU.find(item => {
    const itemPath = item.isRoot ? '/' : `/${item.handle}`;
    return location.pathname === itemPath;
  });

  return (
    <div className="user-account__header">
      {currentItem && (
        <h1 className="heading heading_h2 user-account__header-title">
          {currentItem.label}
        </h1>
      )}
    </div>
  );
};

export default UserHeading;
